export default __webpack_public_path__ + "static/media/echoes-Text.e9b6298f.jpg";